module.exports = __webpack_public_path__ + "static/media/logoMav600.d2eb0c00.jpg";